import { CommonFlags as c, DefaultColumns, EntityColumn, EntityColumnFlags, EntityDefinition } from "@mcurros2/microm";


const columns = () =>
(
    {
        vc_username: new EntityColumn<string>({ name: 'vc_username', type: 'varchar', length: 255, flags: c.Edit, prompt: 'Username' }),
        c_fotofileprocess_id: new EntityColumn<string>({ name: 'c_fotofileprocess_id', type: 'char', length: 20, flags: c.FK | EntityColumnFlags.nullable, prompt: 'Fotofileprocess Id' }),
        vc_fotoguid: new EntityColumn<string>({ name: 'vc_fotoguid', type: 'varchar', length: 255, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Fotoguid' }),
        vc_nombre: new EntityColumn<string>({ name: 'vc_nombre', type: 'varchar', length: 255, flags: EntityColumnFlags.None, prompt: 'Nombre' }),
        vc_apellido: new EntityColumn<string>({ name: 'vc_apellido', type: 'varchar', length: 255, flags: EntityColumnFlags.None, prompt: 'Apellido' }),
        ...DefaultColumns()
    }
)

const views = () =>
(
    {
        pfus_brwStandard: { name: 'pfus_brwStandard', keyMappings: { vc_username: 0 } }
    }
)

export class PerfilUsuarioDef extends EntityDefinition {

    columns = columns();
    views = views();

    constructor() {
        super('PerfilUsuario');
    }
}